import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AppTitleStrategy extends TitleStrategy {
  constructor(private readonly title: Title) {
    super();
  }

  // This method runs automatically on every route change
  override updateTitle(routerState: RouterStateSnapshot) {
    let route = routerState.root;

    while (route.firstChild) {
      route = route.firstChild;
    }

    const title =
      route.data['title'] ||
      route.routeConfig?.title;

    this.title.setTitle(
      title ? `Klinaro - ${title}` : 'Klinaro'
    );
  }
}
